import { render, staticRenderFns } from "./MainImageUpload.vue?vue&type=template&id=61d0f1c9"
import script from "./MainImageUpload.vue?vue&type=script&lang=js"
export * from "./MainImageUpload.vue?vue&type=script&lang=js"
import style0 from "./MainImageUpload.vue?vue&type=style&index=0&id=61d0f1c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports